/**
 * Shared service worker registration. Call getRegistration() to obtain the
 * registration (and trigger registration if not yet done). Registration is
 * typically started from the app entrypoint (e.g. main.tsx on load) so the SW
 * is active early; other code (e.g. UpdateHandler) uses getRegistration() to
 * subscribe to updates or send SKIP_WAITING.
 */

let registrationPromise: Promise<ServiceWorkerRegistration | null> | null =
  null;

/**
 * Returns the current service worker registration, or starts registration and
 * returns a promise that resolves when it's ready. Resolves to null in dev or
 * when the browser has no service worker support.
 */
export function getRegistration(): Promise<ServiceWorkerRegistration | null> {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return Promise.resolve(null);
  }
  if (import.meta.env.DEV) {
    return Promise.resolve(null);
  }
  if (!registrationPromise) {
    registrationPromise = navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => reg);
  }
  return registrationPromise;
}
